import { render, staticRenderFns } from "./SpecialCoupon.vue?vue&type=template&id=1f745979&scoped=true&"
import script from "./SpecialCoupon.vue?vue&type=script&lang=js&"
export * from "./SpecialCoupon.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCoupon.vue?vue&type=style&index=0&id=1f745979&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f745979",
  null
  
)

export default component.exports